// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"674":"0d068596","965":"2d19e580"}[chunkId] + ".js";
};